import React from 'react';
import MainDashboard from './MainDashboard';

/**
 * EnergyDashboard
 * Backwards-compatible wrapper that renders the updated MainDashboard
 * with dedicated Cutter Health, removed Energy and Recent Alerts,
 * matching the reference Industrial IoT design.
 */
const EnergyDashboard = (props) => {
  return <MainDashboard {...props} />;
};

export { MainDashboard };
export default EnergyDashboard;
